"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEMA = void 0;
const SCHEMA = 'iglu:com.angi.entities/component_attributes/jsonschema/4-0-0';
exports.SCHEMA = SCHEMA;
/**
 * Generates the component_attributes context
 *
 * @param componentType - type of component firing the event
 */
const componentAttributesContext = (componentData) => {
    const data = componentData;
    return {
        schema: SCHEMA,
        data,
    };
};
exports.default = componentAttributesContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50QXR0cmlidXRlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9kYXRhU3RydWN0dXJlcy9lbnRpdGllcy9jb21wb25lbnRBdHRyaWJ1dGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLE1BQU0sTUFBTSxHQUFHLDhEQUE4RCxDQUFDO0FBaUJyRSx3QkFBTTtBQWZmOzs7O0dBSUc7QUFDSCxNQUFNLDBCQUEwQixHQUFHLENBQUMsYUFBa0MsRUFBc0IsRUFBRTtJQUMxRixNQUFNLElBQUksR0FBd0IsYUFBb0MsQ0FBQztJQUN2RSxPQUFPO1FBQ0gsTUFBTSxFQUFFLE1BQU07UUFDZCxJQUFJO0tBQ1AsQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVGLGtCQUFlLDBCQUEwQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/dataStructures/entities/componentAttributes.ts